import type { GetImpactRatingsByRatedItemIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetImpactRatingsByRatedItemIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactRatingsByRatedItemIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetImpactRatingsByRatedItemIdArgs = {
  ratedItemId: string;
};

export const useGetImpactRatingsByRatedItemId = createQueryHook<
  UseGetImpactRatingsByRatedItemIdArgs,
  GetImpactRatingsByRatedItemIdResponseRow[],
  GetImpactRatingsByRatedItemIdQuery
>({
  trpcQueryOptions: (trpc, { ratedItemId }) =>
    trpc.frontend.impactRating.impactRatingsByRatedItemId.queryOptions({
      ratedItemId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ impact_rating: data }),
  graphqlDocument: GetImpactRatingsByRatedItemIdDocument,
  graphqlVariables: ({ ratedItemId }) => ({ ratedItemId }),
});
